import React, { useState, useEffect } from 'react';
import { db } from '../../services/firebase';
import { collection, getDocs } from 'firebase/firestore';

const GuestAssignmentModal = ({ isOpen, onClose, onSubmit, currentGuests = [], companyId }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [users, setUsers] = useState([]);
    const [selectedGuests, setSelectedGuests] = useState(currentGuests); // Array of {uid, name, email}

    useEffect(() => {
        if (isOpen && companyId) {
            const loadUsers = async () => {
                try {
                    const snapshot = await getDocs(collection(db, 'companies', companyId, 'users'));
                    const loadedUsers = snapshot.docs.map(doc => ({
                        uid: doc.id,
                        name: `${doc.data().firstName} ${doc.data().lastName}`,
                        email: doc.data().email
                    }));
                    setUsers(loadedUsers);
                } catch (error) {
                    console.error("Fehler beim Laden der User:", error);
                }
            };
            loadUsers();
            setSelectedGuests(currentGuests || []);
        }
    }, [isOpen, companyId, currentGuests]);

    const handleAdd = (user) => {
        if (!selectedGuests.some(g => g.uid === user.uid)) {
            setSelectedGuests([...selectedGuests, user]);
        }
        setSearchTerm('');
    };

    const handleRemove = (uid) => {
        setSelectedGuests(selectedGuests.filter(g => g.uid !== uid));
    };

    const handleSave = () => {
        onSubmit(selectedGuests);
        onClose();
    };

    if (!isOpen) return null;

    const filteredUsers = users.filter(u => 
        (u.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
         u.email.toLowerCase().includes(searchTerm.toLowerCase())) &&
        !selectedGuests.some(g => g.uid === u.uid)
    );

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[80vh]">
                <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center bg-gray-50 dark:bg-gray-900">
                    <h3 className="font-bold text-gray-800 dark:text-white">Gast für diesen Punkt hinzufügen</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
                </div>
                
                <div className="p-4 overflow-y-auto flex-1">
                    <div className="mb-4">
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Person suchen</label>
                        <input 
                            type="text" 
                            placeholder="Name oder E-Mail..." 
                            className="w-full p-2 border rounded-lg dark:bg-gray-700 dark:text-white dark:border-gray-600"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoFocus
                        />
                        {searchTerm && (
                            <div className="mt-2 border rounded-lg max-h-40 overflow-y-auto bg-white dark:bg-gray-700 shadow-sm">
                                {filteredUsers.length === 0 && <div className="p-2 text-gray-400 text-sm">Keine Treffer</div>}
                                {filteredUsers.map(user => (
                                    <button 
                                        key={user.uid} 
                                        onClick={() => handleAdd(user)}
                                        className="w-full text-left p-2 hover:bg-blue-50 dark:hover:bg-gray-600 text-sm flex justify-between items-center"
                                    >
                                        <span>{user.name}</span>
                                        <span className="text-xs text-gray-400">{user.email}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="space-y-2">
                        <label className="block text-xs font-bold text-gray-500 uppercase">Ausgewählte Gäste</label>
                        {selectedGuests.length === 0 ? (
                            <p className="text-sm text-gray-400 italic">Noch niemand ausgewählt.</p>
                        ) : (
                            selectedGuests.map(guest => (
                                <div key={guest.uid} className="flex justify-between items-center bg-orange-50 dark:bg-orange-900/20 border border-orange-100 dark:border-orange-800 p-2 rounded text-sm">
                                    <span className="text-orange-800 dark:text-orange-200 font-medium">{guest.name}</span>
                                    <button onClick={() => handleRemove(guest.uid)} className="text-orange-400 hover:text-orange-600">✕</button>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                <div className="p-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 flex justify-end gap-2">
                    <button onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-200 rounded-lg text-sm">Abbrechen</button>
                    <button onClick={handleSave} className="px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-lg text-sm font-bold shadow">Übernehmen</button>
                </div>
            </div>
        </div>
    );
};

export default GuestAssignmentModal;